import React, { useContext, useState, useEffect } from 'react'
import { auth, googleAuthProvider } from '../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signInWithPopup } from 'firebase/auth';
import { db } from '../firebase';
import { getDoc, doc } from 'firebase/firestore';

const AuthContext = React.createContext()

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider( {children} ) {
    const [currentUser, setCurrentUser] = useState();
    const [loading, setLoading] = useState(true);

    function signupWithEmail(email, password) {
        return createUserWithEmailAndPassword(auth, email, password)
    }

    function loginWithEmail(email, password) {
        return signInWithEmailAndPassword(auth, email, password)
    }

    function logout() {
        return auth.signOut();
    }

    function authenticateWithGoogle() {
        return signInWithPopup(auth, googleAuthProvider)
    }

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
        setCurrentUser(user);
        setLoading(false);
        })
        
        return unsubscribe
    }, [])
    

    const value = {
        currentUser,
        signupWithEmail,
        loginWithEmail,
        authenticateWithGoogle,
        logout
    }

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}
